import { VEHICLE_SEARCH_URL } from '../constants'
import { SearchResponse } from '../types/vehicle-counts'

/**
 * @deprecated Use the data-search-vehicles-api lib's `fetchSearchVehicles` hook instead
 */
export const getSearchAPIData = async (): Promise<SearchResponse> => {
  const response = (await fetch(VEHICLE_SEARCH_URL).then((res) =>
    res.json(),
  )) as SearchResponse
  return response
}

/**
 * @deprecated Use the data-search-vehicles-api lib's `fetchSearchVehicles` hook instead, setting vehicleIds, excludeUnavailable and queryOnly
 */
export const getSelectedVehiclesAPIData = async (
  vehicleIds: string,
): Promise<SearchResponse> => {
  const response = (await fetch(
    `${VEHICLE_SEARCH_URL}?vehicleIds=${vehicleIds}&excludeUnavailable=false&queryOnly=true`,
  ).then((res) => res.json())) as SearchResponse
  return response
}
